/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type SocialRegister201Status = typeof SocialRegister201Status[keyof typeof SocialRegister201Status];


export const SocialRegister201Status = {
  REGISTRATION_COMPLETE: 'REGISTRATION_COMPLETE',
} as const;
